import { GetterTree } from "vuex";
import { RootState } from "@/store/types";

export const getters: GetterTree<RootState, RootState> = {
  loggedIn: state => {
    return state.loggedInUser && state.loggedInUser.id !== "0";
  },
};
